import HttpClient from "../../services/http/HttpClient";
import {env} from "../../../res/config/env";
import {api} from "../../../res/rest/api";
import {request} from "../../../res/rest/restRequest";

const getNewOrderRequest = async (session) => {
    const cartData = {
        "AD_Org_ID": {
            "id": session.orgID,
            "tableName": "AD_Org"
        },
        "isActive": true,
        "description": "Web Order",
        "C_BPartner_ID": session.bPartnerID,

        "tableName": "C_Order",

        "PaymentRule": "T",
        "C_DocTypeTarget_ID": 1000047,
        "C_DocType_ID": {
            "identifier": "Web Order",
            "model-name": "c_doctype"
        },

        "IsSOTrx": true
    }

    const req = request.model("c_order")
        .buildRequest(env.API_URL);

    const cartResp = await HttpClient.client.post(req, cartData, api.auth(session));
    return cartResp.data;
}

export default getNewOrderRequest;
